export default __webpack_public_path__ + "static/media/cablered-cut.c57fe82f.png";